/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Errors_Invitee_Is_AdminInputs */

const nl_invite_errors_invitee_is_admin = /** @type {(inputs: Invite_Errors_Invitee_Is_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit e-mailadres hoort bij een beheerdersaccount en kan niet als docent worden uitgenodigd`)
};

/**

* @param {Invite_Errors_Invitee_Is_AdminInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const invite_errors_invitee_is_admin = /** @type {((inputs?: Invite_Errors_Invitee_Is_AdminInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Errors_Invitee_Is_AdminInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_invite_errors_invitee_is_admin(inputs)
});
export { invite_errors_invitee_is_admin as "invite.errors.invitee_is_admin" }